var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"issue"},[_c('h2',[_vm._v("常见问题")]),_c('div',{staticClass:"issue_top"},_vm._l((_vm.problemList),function(item){return _c('div',{key:item.article_id},[_c('p',{staticStyle:{"cursor":"pointer"},on:{"click":function($event){return _vm.getList(item.article_id)}}},[_vm._v(_vm._s(item.title))])])}),0)])])
}
var staticRenderFns = []

export { render, staticRenderFns }